import { MobileMenu } from './parts/mobile-menu.js';
// import './parts/megamenu';
import './parts/header.js';
import './parts/search';
import './parts/sliders.js';
import './parts/donate.js';

document.addEventListener("DOMContentLoaded", () => {

	// Init Mmenu Light
	MobileMenu( "responsive-menu" );

	let scrollButton = document.querySelector('.footer--scrolltop');

	if( scrollButton ){
		scrollButton.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
	}

	// Arrow to scrolldown on homepage
	let firstBlock = document.querySelector('body.home #main > :first-child');

	if( firstBlock ){
		if( firstBlock.classList.contains('cover-slider') || firstBlock.classList.contains('wp-block-cover') ){
			// Creates the button
			let arrow = document.createElement('button');
			arrow.className = 'scroll-down-arrow';
			// Adds the click event to scroll to next block
			arrow.addEventListener('click', e => {
				const nextBlock = firstBlock?.nextElementSibling;
				nextBlock?.scrollIntoView({ behavior: 'smooth', block: 'start' });
			} )
			// adds the element to the cover/cover slider block
			firstBlock.appendChild(arrow);
		}
	}

});